import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiQueryKeys } from "#lib/AiQueryKeys.ts";
import { useSuspenseQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

export const useGetCurrentUserSuspenseQuery = () => {
    const { getCurrentUser } = useAiApiClient();
    const { i18n } = useTranslation();

    return useSuspenseQuery({
        queryKey: AiQueryKeys.GetCurrentUser(),
        gcTime: Infinity,
        queryFn: async() => {
            const data = await getCurrentUser();
            i18n.changeLanguage(data.language);

            return data;
        }
    });
};
